import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SportsAdventureComponent } from './sports-adventure.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: SportsAdventureComponent,
    data: {
      title: "SportsAdventure",
      breadcrumb: "SportsAdventure"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class SportsAdventureRoutingModule { }